import React from 'react';
import { connect } from 'react-redux';
// utils
import {
  Translations,
  electOwningCase,
  getProjectStatus,
  shoudlDisableAllCaseBodyFooterBtns,
  shoudlDisableCancelBtn,
  shoudlEnableGenerateDraftBtn
} from '../../../utils';

// constant
import { CASE_CANCELLED, CASE_COMPLETED, CASE_STATUS_LEVEL_LOOKUP_TABLE } from '../../../constants';

// restClient
import { aemHostClient, eapiClient } from '../../../restClient';

// children
import Banner from '../../common/Banner/';
import NavigationList from '../../common/NavigationList/';

//action Creator
import { blockUi, unBlockUi } from '../../../actions/actionCreator';
import { cryptoPass } from '../../../utils';
import { updateCasesWithStatus } from '../../createAcase/actions/actionCreator';
import { setDarkTitleBarContent, updateDarkTitleBarCaseStatus } from '../../layouts/actions/actionCreator';
import {
  disableAllCaseBodyFooterBtns,
  disableCaseBodyFooterBtn,
  disableTabs,
  enableCaseBodyFooterBtn,
  setTabsStatus
} from '../actions/actionCreator';

//style
import './styles.css';

class CustomerDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bannersVisibility: {}
    };
    this.caseStatuses = [];
  }

  componentWillMount() {
    document.title = `${"Customer Details"} - ${'HSBC GLCM'}`;
  }

  componentDidMount() {
    this.getCustomerEntityStatus()
  }

  getCustomerEntityStatus = async () => {
    this.props.blockUi();
    let tab = await cryptoPass('customer-tab',);
    window.sessionStorage.removeItem("tab");
    window.localStorage.setItem('tab', tab);
    eapiClient("/cases/customerEntityStatus/" + this.props.owningCase.caseId, { timeout: 420000 })
      .then(({ data, status }) => {
        this.setState({ customerDetails: data.responseData.data });
        this.props.updateDarkTitleBarCaseStatus(getProjectStatus(this.props.owningCase.caseId, data.responseData.caseStatuses));
        this.props.setTabsStatus('customerDetailsTab', data.responseData.tabStatus === "complete");
        this.caseStatuses = data.responseData.caseStatuses;

        const { caseStatuses } = data.responseData;
        this.props.updateCasesWithStatus(caseStatuses);
        if (shoudlEnableGenerateDraftBtn(caseStatuses)) {
          this.props.enableCaseBodyFooterBtn('generateDocumentationBtn');
        } else {
          this.props.disableCaseBodyFooterBtn('generateDocumentationBtn');
        }
        if (shoudlDisableCancelBtn(caseStatuses)) {
          this.props.disableCaseBodyFooterBtn('cancelBtn');
        } else {
          this.props.enableCaseBodyFooterBtn('cancelBtn');
        }
        if (shoudlDisableAllCaseBodyFooterBtns(caseStatuses)) {
          this.props.disableAllCaseBodyFooterBtns();
          this.props.disableTabs('customerDetailsTab', 'productRequestsTab', 'documentationTab', 'activationTab')
        }
        this.props.unBlockUi();
      });
  }

  backTocreatecase = () => {
    aemHostClient("/aemData/formData/json_add-entity")
      .then(({ data, status }) => {
        document.title = `${Translations(data.par.page_title_mainTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)} - ${'HSBC GLCM'}`
        this.props.history.push('/case-body/add-customer-from-case-body', { createCasePageJson: data })
      });

  }

  shouldDisableAddCustomerBtn = (caseStatuses) => {
    if (caseStatuses.length === 1) {
      if (caseStatuses[0].statusKey === CASE_COMPLETED || caseStatuses[0].statusKey === CASE_CANCELLED) {
        return true;
      }
    } else {
      var _shouldDisable = true;
      caseStatuses.forEach(caseStatus => {
        if (CASE_STATUS_LEVEL_LOOKUP_TABLE[caseStatus.statusKey] < 5) {
          _shouldDisable = false;
        }
      });
      return _shouldDisable;
    }
  }

  onBannerClose = (bannerId) => {
    this.setState({
      bannersVisibility: { ...this.state.bannersVisibility, [bannerId]: true }
    });
  }

  render() {
    const caseStatus = CASE_STATUS_LEVEL_LOOKUP_TABLE[this.props.status];
    return (
      <div className="customer-details-tab">
        {
          this.props.customer && caseStatus < 3
            ? <Banner
              bannerType="primary"
              actionText={Translations(this.props.customerPageJson.notification_CustomercustomerDetailNotification.closeText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              bannerId="ci-customer-banner"
              actionCallback={this.onBannerClose}
              hide={this.state.bannersVisibility['ci-customer-banner']}
            >
              {Translations(this.props.customerPageJson.notification_CustomercustomerDetailNotification.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
            </Banner>
            : !this.props.customer
              ? <button
                onClick={this.backTocreatecase}
                className='gdocs-btn-default'
                disabled={this.shouldDisableAddCustomerBtn(this.caseStatuses) || this.props.caseMenu.isEditing}
              >
                <span className="icon icon-add addicon"></span>
                {Translations(this.props.customerPageJson.button_addCustomer.text, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              </button>
              : ''
        }
        {
          !this.props.customer ?
            <Banner
              bannerType="primary"
              actionText={this.props.customerPageJson !== undefined ? Translations(this.props.customerPageJson.notification_CustomerDetailNotification.closeText, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
              bannerId="ci-customer-banner"
              actionCallback={this.onBannerClose}
              hide={this.state.bannersVisibility['ci-customer-banner']}
            >
              {this.props.customerPageJson !== undefined ? Translations(this.props.customerPageJson.notification_CustomerDetailNotification.text, this.props.lang.currentLang.lang, this.props.lang.translatedData) : ''}
            </Banner>
            : ''
        }
        <p className="customers-name">
          {Translations(this.props.customerPageJson.navigation_list_customerList.title, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
        </p>
        <NavigationList
          cases={this.props.cases}
          entities={this.props.entities}
          history={this.props.history}
          lang={this.props.lang.currentLang.lang}
          listtype="caseBodyCustomerDetails"
          properties={{ customerDetailsStatuses: this.state.customerDetails }}
        />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    customer: state.auth.userDetails.roleDetails.customer,
    caseMenu: state.caseMenuInfo,
    status: (electOwningCase(state.cases) && electOwningCase(state.cases).status) || '',
    entities: state.entities,
    owningCase: electOwningCase(state.cases) || {},
    lang: state.lang
  }
}
const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args));
    },
    setTabsStatus: (tabName, isComplete) => {
      dispatch(setTabsStatus(tabName, isComplete));
    },
    disableTabs: (...tabNames) => {
      dispatch(disableTabs(...tabNames));
    },
    disableAllCaseBodyFooterBtns: () => {
      dispatch(disableAllCaseBodyFooterBtns())
    },
    updateDarkTitleBarCaseStatus: caseStatus => {
      dispatch(updateDarkTitleBarCaseStatus(caseStatus));
    },
    enableCaseBodyFooterBtn: (btnName) => {
      dispatch(enableCaseBodyFooterBtn(btnName));
    },
    disableCaseBodyFooterBtn: (btnName) => {
      dispatch(disableCaseBodyFooterBtn(btnName));
    },
    updateCasesWithStatus: (caseStatuses) => {
      dispatch(updateCasesWithStatus(caseStatuses));
    },
    blockUi: () => {
      dispatch(blockUi())
    },
    unBlockUi: () => {
      dispatch(unBlockUi())
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(CustomerDetails);



// WEBPACK FOOTER //
// ./src/components/CaseBody/CustomerDetails/index.js